import React, { useCallback, useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import Step from '../../../../../../../features/components/Forms/StepForm/Step'
import Dv360AdvancedAudienceFields from './Dv360AdvancedAudienceFields'

import { selectedPartnershipSelector } from '../../../../../../../modules/selectors/partnerships'
import { audiencesSelector } from '../../../../../../../modules/selectors/audiences'
import { clearAudiences, getAudiences } from '../../../../../../../modules/actions/audiences'
import { selectedDV360AdAccountSelector } from '../../../../../../../modules/selectors/adAccounts'

import { DV_360_PLATFORM } from '../../../../../../../constants/selectLists/platformList'
import {
  CUSTOM_AUDIENCES,
  CUSTOM_AUDIENCES_EXCLUSION
} from '../../../../../../ReusableFormFields/Audiences/AudiencesFields/fields'
import { CUSTOM_AGE_RANGES } from '../../../../../../ReusableFormFields/AgeRangesFields/fields'

const stepFields = [CUSTOM_AUDIENCES, CUSTOM_AUDIENCES_EXCLUSION, CUSTOM_AGE_RANGES]

const AudiencesStep = ({ formik, handleStepChange }) => {
  const dispatch = useDispatch()

  const { id: selectedAdAccountId } = useSelector(selectedDV360AdAccountSelector)

  const selectedPartnership = useSelector(selectedPartnershipSelector)
  const { rights_holder_name: rightsHolderName } = selectedPartnership

  const audiences = useSelector(audiencesSelector)

  const formattedAudiences = useMemo(
    () =>
      audiences.map(({ id, name }) => ({
        value: id,
        label: name
      })),
    [audiences]
  )

  const handleContinue = useCallback(() => {
    handleStepChange(stepFields)
  }, [handleStepChange])

  useEffect(() => {
    dispatch(
      getAudiences(
        {
          account: selectedAdAccountId,
          filter_by_account_id: true,
          limit: 9999
        },
        DV_360_PLATFORM
      )
    )
  }, [dispatch, selectedAdAccountId])

  useEffect(
    () => () => {
      dispatch(clearAudiences())
    },
    [dispatch]
  )

  return (
    <Step stepTitle={`Do you want to target ${rightsHolderName}  audiences?`} handleContinue={handleContinue}>
      <Dv360AdvancedAudienceFields formik={formik} formattedAudiences={formattedAudiences} />
    </Step>
  )
}

export default AudiencesStep
